import { Injectable, Signal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DebugHelperService {
  shouldShowIds: Signal<boolean>;

  #showIds = signal<boolean>(null);

  constructor() {
    this.shouldShowIds = this.#showIds.asReadonly();
  }

  setShowIds(value: boolean): void {
    this.#showIds.set(value);
  }
}
